module.exports = __webpack_public_path__ + "img/icon-clean.6188a898.svg";